export const PARTS_UV_TYPES = ['0', '2', '3', '5'];
